// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"5af01b81","931":"faffe2a3"}[chunkId] + ".chunk.js";
};